export default __webpack_public_path__ + "static/media/BB_47.495197c6.png";